import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import InstagramGallery from '../components/InstagramGallery';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import ChatWidget from '../components/ChatWidget';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <Testimonials />
        <InstagramGallery />
        <ContactForm />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

export default LandingPage;
